import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="bg-ice px-4 py-5 sm:px-6" data-id="element-31" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-32" data-mp="1mb3wmvm5qqkc">
        <h2 className="font-heading text-base font-extrabold uppercase leading-tight text-deep sm:text-2xl" data-id="element-33" data-mp="1r3naltorbnpo">
          This isn’t just another ophthalmology ebook
        </h2>
        <p className="mt-1 font-heading text-[0.8rem] font-bold uppercase text-turq sm:text-base" data-id="element-34" data-mp="zd0q2nb7s2b9">
          It’s a complete ready-to-use visual study system.
        </p>
        <div className="mt-3 grid grid-cols-1 gap-2 text-left sm:grid-cols-2" data-id="element-35" data-mp="13gf7nieswqqt">
          {differentiators.map(item => <div key={item.title} className="flex gap-2.5 rounded-xl bg-white p-2.5 shadow-sm" data-id="element-36" data-mp="1dc8rlmuunmim">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-37" data-mp="2jrsvcgft9cpi">
                {item.emoji}
              </span>
              <div data-id="element-38" data-mp="2opufz5svxk33">
                <h3 className="font-heading text-[0.82rem] font-bold text-deep sm:text-base" data-id="element-39" data-mp="2otiaa765maiv">
                  {item.title}
                </h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-muted sm:text-sm" data-id="element-40" data-mp="7oaa8tbibrhm">
                  {item.body}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}